export default [
  {
    path: '/content/download',
    name: 'Content Download List',
    component: () => import('@/views/content/download/index.vue'),
    meta: {
      icon: 'el-icon-s-data',
      resourceCode: 'content:download',
      name: 'message.download.downloadCenter',
    },
  },
  {
    path: '/content/notice/list',
    name: 'Message Center',
    component: () => import('@/views/content/notice/list/index.vue'),
    meta: {
      resourceCode: 'notice:list',
      name: 'message.notice.noticeCenter',
    },
  },
  {
    path: '/content/notice/detail',
    name: 'Message Detail',
    component: () => import('@/views/content/notice/detail/index.vue'),
    meta: {
      resourceCode: 'notice:detail',
      name: 'message.notice.noticeDetail',
    },
  },
  {
    path: '/content/upload',
    name: 'Upload Details',
    component: () => import('@/views/content/upload/index.vue'),
    meta: {
      resourceCode: 'content:upload',
      name: 'message.transaction.uploadDetails',
    },
  },
];
